/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeclineOfferInterface } from '../models/DeclineOfferInterface';
import type { FormResultInterface } from '../models/FormResultInterface';
import type { FormResultsResponse } from '../models/FormResultsResponse';
import type { OpenApiInteger } from '../models/OpenApiInteger';
import type { WaitlistAcceptOfferInterface } from '../models/WaitlistAcceptOfferInterface';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormResultsService {

    /**
     * @param formResultIds
     * @returns FormResultsResponse List of FormResults
     * @throws ApiError
     */
    public static getFormResults(
        formResultIds: string,
    ): CancelablePromise<FormResultsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/form-results',
            query: {
                'formResultIds': formResultIds,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * @param offerToken
     * @returns FormResultInterface FormResult
     * @throws ApiError
     */
    public static getFormResultByOfferToken(
        offerToken: string,
    ): CancelablePromise<FormResultInterface> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/form-results/{offerToken}',
            path: {
                'offerToken': offerToken,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param id
     * @returns DeclineOfferInterface Decline Offer
     * @throws ApiError
     */
    public static declineOffer(
        id: OpenApiInteger,
    ): CancelablePromise<DeclineOfferInterface> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/form-results/{id}/decline-offer',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @param offerToken
     * @returns WaitlistAcceptOfferInterface Waitlist Accept Offer
     * @throws ApiError
     */
    public static waitlistAcceptOffer(
        offerToken: string,
    ): CancelablePromise<WaitlistAcceptOfferInterface> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/form-results/{offerToken}/waitlist-accept-offer',
            path: {
                'offerToken': offerToken,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

}
